import type { ParentComponent } from "solid-js";
import { Portal as SolidPortal } from "solid-js/web";

const Portal: ParentComponent = (props) => {
  const storybookRoot = document.getElementById("portal-container");

  return <SolidPortal mount={storybookRoot ?? document.body}>{props.children}</SolidPortal>;
};

export default Portal;
